import { ButtonV3, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';

interface NewsroomAccordionContentProps {
  readonly subcopy: string | undefined;
  readonly url: string | undefined;
}

export const NewsroomAccordionContent = ({
  subcopy,
  url,
}: NewsroomAccordionContentProps) => {
  const t = useTranslations();
  const handleReadMoreClick = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'Read More',
      location: 'Newsroom Page',
      path: url,
      action: 'go to article',
    });
  };
  return (
    <>
      <TypographyV3 className="mt-0 mb-5" data-cy="newsroom-subcopy">
        {t(subcopy ?? '')}
      </TypographyV3>
      <ButtonV3
        data-cy="newsroom-read-more"
        href={url ?? ''}
        variant="secondary-dark"
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleReadMoreClick}
      >
        {t('read_more')}
      </ButtonV3>
    </>
  );
};
